import { AgxApi } from '../../helpers/http';

export const agenciesApi = (authToken: string) => new AgxApi('agencies', authToken);
